import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { BaseDataResponse, BaseEntityResponse, CredentialActivityStatus, WebAPIRequest, WebAPIRequestListParams } from "@base/entities/BaseEntities";
import { APIGatewayService } from "../gateway/APIGateway.service";
import {DataLoadOptions} from "@base/datalayer/DataLoadOptions";
import { BaseEndpointCRUD } from "@m4u-angular/base/endpoint/BaseEndpointCRUD";

@Injectable()
export class WebAPIRequestEndpoint extends BaseEndpointCRUD<WebAPIRequest>
{
    //Constructor
    constructor(api: APIGatewayService) {
        super("WebAPIRequest", api);
    }
    
    public ListEx(Params: WebAPIRequestListParams, options: DataLoadOptions): Observable<BaseEntityResponse<CredentialActivityStatus>> {
        return this.api.ExecutePostAction(this.ControllerName, 'ListEx', Params, {options: options?.GetLoadOptions()});
    }

    public GetPossibleControllers(): Observable<BaseDataResponse<string[]>> {
        return this.api.ExecuteGetAction(this.ControllerName, 'GetPossibleControllers');
    }

    public GetPossibleActions(): Observable<BaseDataResponse<string[]>> {
        return this.api.ExecuteGetAction(this.ControllerName, 'GetPossibleActions');
    }

    public GetPossibleModules(): Observable<BaseDataResponse<string[]>> {
        return this.api.ExecuteGetAction(this.ControllerName, 'GetPossibleModules');
    }
}
